<template>
  <v-expansion-panels flat accordion>
    <v-expansion-panel>
      <v-expansion-panel-header
        :style="
          $route.query.embed
            ? 'border-bottom: 1px solid #dfdfdf; border-top: 1px solid #dfdfdf; height: 90px'
            : `${
                !$vuetify.breakpoint.mdAndUp
                  ? 'border-top: 1px solid #dfdfdf;'
                  : ''
              } height: 85px`
        "
      >
        <v-row no-gutters>
          <b class="checkout-h3 title-group accent--text">{{
            eventDetails.campanha_cartao.nome
          }}</b>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="product-expansion-panel">
        <div slot="header" class="panel-header"></div>

        <v-card flat>
          <v-text-field
            v-model="digits"
            outlined
            v-mask="'######'"
            label="Insira os 6 primeiros dígitos do seu cartão de crédito"
          ></v-text-field>
          <v-layout justify-center>
            <v-btn
              @click="applyCodeCard"
              rounded
              color="primary"
              depressed
              height="40"
              width="100%"
              style="text-transform: none"
              >{{ $t("cart.apply") }}</v-btn
            >
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex/dist/vuex.common.js";
export default {
  directives: { mask },
  props: ["eventDetails"],
  data() {
    return {
      digits: null,
    };
  },

  computed: {
    ...mapGetters(["eventId"]),
  },

  methods: {
    async applyCodeCard() {
      this.$store.commit("SET_COUPON_CARD", this.digits);
      localStorage.setItem(`isCouponCard-${this.eventId}`, this.digits);
      localStorage.setItem(`couponCode-${this.eventId}`, this.digits);
      await this.$store.dispatch("getProductsAndSectors", {
        event: this.eventId,
        coupon: this.digits,
      });
    },
  },
};
</script>
